import { QAppsCountCard, QAppVersionsChartCard } from '@kw/quokka-ui';
import { createSearchParams, useNavigate } from 'react-router-dom';
import { Box } from '@mui/material';
import { DashboardAnalyticsDateRangeDays, DashboardAnalyticsMetrics, rollingSubmittedDateRange } from './dashboardAnalytics';
import moment from 'moment';

type AppInventoryProps = {
  dateRangeDays: DashboardAnalyticsDateRangeDays;
  metrics: DashboardAnalyticsMetrics | null | undefined;
};

export const AppInventory = ({ dateRangeDays, metrics }: AppInventoryProps) => {
  const navigate = useNavigate();

  const navigateToApplications = (platform: 'all' | 'android' | 'ios') => {
    const { startDate, endDate } = rollingSubmittedDateRange(dateRangeDays);
    navigate({
      pathname: '/applications',
      search: createSearchParams({
        platform,
        startDate,
        endDate,
      }).toString(),
    });
  };

  const appsOverTime = (metrics?.appsOverTime ?? []).map(entry => ({
    ...entry,
    date: moment(entry.date).format('MMM D'),
  }));

  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: 'repeat(3, 1fr)',
        gap: '24px',
        '& .MuiPaper-root': { width: '100%' },
      }}
    >
      {/* Row 1: Summary cards — each takes 1/3 */}
      <QAppsCountCard
        data-testid="total-versions-card"
        variant="total"
        versionsCount={metrics?.totalVersionsAll}
        uniqueAppsCount={metrics?.uniqueAppsAll}
        onClick={() => navigateToApplications('all')}
      />
      <QAppsCountCard
        data-testid="android-versions-card"
        variant="android"
        versionsCount={metrics?.totalVersionsAndroid}
        uniqueAppsCount={metrics?.uniqueAppsAndroid}
        onClick={() => navigateToApplications('android')}
      />
      <QAppsCountCard
        data-testid="ios-versions-card"
        variant="ios"
        versionsCount={metrics?.totalVersionsIos}
        uniqueAppsCount={metrics?.uniqueAppsIos}
        onClick={() => navigateToApplications('ios')}
      />

      {/* Row 2: Chart takes 2/3, placeholder takes 1/3 */}
      <Box sx={{ gridColumn: 'span 2' }}>
        <QAppVersionsChartCard data={appsOverTime} />
      </Box>
      <Box>{/* Newly Submitted Apps card placeholder */}</Box>
    </Box>
  );
};
